import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createPortal } from 'react-dom';
export function ErrorBoundaryView({ hasError, error, setHasError, }) {
    return (_jsx(_Fragment, { children: createPortal(_jsxs("div", { role: "presentation", id: "dialog-wrapper", children: [_jsx("style", { children: styles }), _jsxs("dialog", { className: "dialog", open: hasError, children: [_jsxs("h1", { children: ["Laufzeitfehler (", error?.name, ")"] }), _jsx("p", { children: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es in wenigen Minuten erneut. Sollte das Problem weiterhin bestehen, wenden Sie sich bitte an den IT-Helpdesk unter der Nummer 1111." }), _jsx("div", { className: "error-container", children: _jsx("div", { className: "error-item", children: _jsxs("p", { className: "error error-value", children: [error?.name, ": ", error?.message] }) }) }), _jsx("button", { onClick: () => {
                                document.location.href = '/';
                                setHasError(); // this have no effect. cause we reloading the entire page
                            }, children: "zur Startseite" })] })] }), document.body) }));
}
const styles = `
  dialog {
  color: #5D6162;
  font-size: 0.875rem;
  font-weight: 300;
  letter-spacing: 0.036rem;
  line-height: 1.625;
  font-family: "Zurich Sans", "Helvetica Neue", Arial, sans-serif;
  position: absolute;
  width: 940px;
  max-width: 80vw;
  border-radius: 8px;
  padding: 20px;
  background-color: #fff;
  border: 1px solid #bbb;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  top: 50%;
  transform: translateY(-50%);
  z-index: 100;
  h1,
  h2 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: 300;
    letter-spacing: 0.02rem;
    color: #23366f;
    line-height: 1.5625;
  }

  h1 {
    font-size: 2rem;
  }

  button {
    padding: 10px 20px;
    background-color: #23366f;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    transition: background-color 0.25s ease-out;
    display: block;
    margin: 24px 0 0 auto;
    font-size: 1rem;
    font-weight: 300;
    letter-spacing: 0.047rem;
    color: #ffffff;
    line-height: 1.5625;
  }

  p {
    &.error {
      margin: 0;
    }
  }

  .error-value {
    padding: 8px 16px;
    border-left: 2px solid #ff5555;
    font-weight: bold;
    color: #ff5555;
    background-color: #f2f2f2;
  }

  .error-container {
    display: grid;
    gap: 24px;
  }
}

#dialog-wrapper::after {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  transition: backgroundColor 0.6s ease-out;
  z-index: 10;
}

dialog button:hover {
  background-color: #2167ae;
}
  `;
